import styled from 'styled-components';

export const InputRadioStyled = styled.input`
  display: flex;
  align-items: center;
  place-content: center;
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  appearance: none;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;

  &:checked::after {
    content: '';
    width: 1rem;
    height: 1rem;
    background-color: ${({ theme }) => theme.colors.garnet};
    border-radius: 50%;
    position: absolute;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 1.6rem;
    height: 1.6rem;
    &:checked::after {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
`;
